import * as React from "react";
import ErrorImg from "~/app/assets/images/error-403-access.png";
import "../styles/index.css";
import PageTitle from "~shared/components/pageTitle/SEO.js";
const AccessDenied = () => {
  return (<>
    <PageTitle title="Access Denied"/>
    <div className="access-denied-container">
      <div className="access-denied-holder">
        <div className="access-denied-forbidden-container">
          <img className="access-denied-image" src={ErrorImg} alt="" />
        </div>
        <div style={{ textAlign: "center" }}>
          <h1 className="access-denied-forbidden">403 Forbidden: Access Denied</h1>
          <p>Please login to use the application.</p>
        </div>
      </div>
    </div>
    </>
  );
};

export default AccessDenied;
